import * as React from 'react';
import classNames from 'classnames';
import toArray from 'rc-util/lib/Children/toArray';
import Popover from '../popover';
import { cloneElement } from '../_util/reactNode';
import ConfigContext from '../config-provider/ConfigContext';
import { Size } from '../_util/enum';
import { AvatarContextProvider } from './AvatarContext';
export default class Group extends React.Component {
    static get contextType() {
        return ConfigContext;
    }
    render() {
        const { prefixCls: customizePrefixCls, className, maxCount, maxStyle, size, style, children, maxPopoverPlacement, maxPopoverTrigger } = this.props;
        const { getPrefixCls } = this.context;
        const prefixCls = getPrefixCls('avatar-group', customizePrefixCls);
        const cls = classNames(prefixCls, className);
        const childrenWithProps = toArray(children).map((child, index) => cloneElement(child, {
            key: `avatar-key-${index}`,
        }));
        const numOfChildren = childrenWithProps.length;
        if (maxCount && maxCount < numOfChildren) {
            const childrenShow = childrenWithProps.slice(0, maxCount);
            const childrenHidden = childrenWithProps.slice(maxCount, numOfChildren);
            const numberCls = `${prefixCls}-popover-number`;
            const popverNumberCls = classNames(numberCls, {
                [`${numberCls}-lg`]: size === Size.large,
                [`${numberCls}-sm`]: size === Size.small,
            });
            const additionNumber = Math.min(numOfChildren - maxCount, 99);
            childrenShow.push(React.createElement(Popover, { key: "avatar-popover-key", content: childrenHidden, trigger: maxPopoverTrigger, placement: maxPopoverPlacement, overlayClassName: `${prefixCls}-popover` },
                React.createElement("span", { className: `${prefixCls}-popover-mask` },
                    childrenHidden[0],
                    React.createElement("span", { style: maxStyle, "data-contentlength": `+${additionNumber}`.length, className: popverNumberCls },
                        "+",
                        additionNumber))));
            return (React.createElement(AvatarContextProvider, { size: size, getPrefixCls: getPrefixCls },
                React.createElement("div", { className: cls, style: style }, childrenShow)));
        }
        return (React.createElement(AvatarContextProvider, { size: size, getPrefixCls: getPrefixCls },
            React.createElement("div", { className: cls, style: style }, childrenWithProps)));
    }
}
Group.displayName = 'AvatarGroup';
Group.defaultProps = {
    size: Size.default,
    maxPopoverPlacement: 'top',
    maxPopoverTrigger: 'hover',
    className: '',
};
